import API from '../config/api.js'

export const CommonService = {

    getBranches() {
        return API.get("/api/common/branches");
    },

    getFinancialYears() {
        return API.get("/api/common/getFinancialYears");
    },

    getCountries() {
        return API.get("/api/common/getCountries");
    },


}
    